module.exports = __webpack_public_path__ + "static/media/faqBalance-es-de.015ab4de.vtt";